import "@arco-design/web-react/es/Popconfirm/style";
import _Popconfirm from "@arco-design/web-react/es/Popconfirm";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import React from 'react';
export function ButtonConfirm({
  onOk,
  loading,
  actionName = '操作',
  actionTitle = '确定该操作?'
}) {
  return /*#__PURE__*/React.createElement(_Popconfirm, {
    title: actionTitle,
    onOk: onOk
  }, /*#__PURE__*/React.createElement(_Button, {
    type: "secondary",
    status: "danger",
    size: "small",
    loading: loading
  }, actionName));
}